import { useOktaAuth } from '@okta/okta-react';
import { useBoolean } from 'ahooks';
import React, { FC, useEffect } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { LS_TEMPLATE_ID_KEY } from 'constant';
import { useQueryParams } from 'hooks/use-query-params';
import { logger } from 'services';

export const SessionLogin: FC = () => {
  const { oktaAuth } = useOktaAuth();
  const params = useQueryParams();
  const sessionToken = params.get('token');
  const templateId = params.get('templateId');

  const [isSessionLoading, { setTrue, setFalse }] = useBoolean(false);

  useEffect(() => {
    if (templateId === undefined || templateId === null) {
      if (sessionToken) {
        setTrue();
        oktaAuth.token
          .getWithRedirect({ sessionToken, prompt: 'none' })
          .catch((error) => {
            logger.error('token setup failed', { error });
            setFalse();
          });
      }
    } else if (sessionToken) {
      localStorage.setItem(LS_TEMPLATE_ID_KEY, templateId);
      setTrue();
      oktaAuth.token
        .getWithRedirect({
          sessionToken,
          prompt: 'none',
          extraParams: { templateId },
        })
        .catch((error) => {
          logger.error('token setup failed', { error });
          setFalse();
        });
    }
  }, [setTrue, setFalse, oktaAuth, sessionToken, templateId]);

  if (isSessionLoading) {
    return <PageLoading />;
  }

  return null;
};
